<div class="order-item" *ngIf="data.orderItem as orderItem">
  <x-media-thumbnail
    [url]="orderItem.media.url"
    width="65"
    height="65"
    crop="fit"
  ></x-media-thumbnail>
  <div class="info">
    <small class="text-nowrap" i18n="@@Checkout.AddedToBag">Added to bag</small>
    <div class="text-nowrap name mat-body-1 m-0">
      {{ orderItem.productName }}
    </div>
  </div>
</div>
